/**
 * Types inlined from copilot-toolkit — the dependency was intentionally
 * removed from ai-rendering-library to keep the rendering layer decoupled
 * from the toolkit (see https://hubspot.slack.com/archives/C088Z9H9NMT/p1741953781473499).
 * If the source types change, update these to match.
 * @see https://github.com/HubSpotEngineering/copilot-toolkit/blob/master/copilot-toolkit/static/js/custom-components/index.ts
 */

const registryMap = new Map();

/** Register a namespace's components. Throws in dev on duplicate namespace; silently overwrites in production for hot-reload. */
export function registerComponentRegistry(...entries) {
  for (const entry of entries) {
    if (process.env.NODE_ENV !== 'production' && registryMap.has(entry.namespace)) {
      throw new Error(`[CustomComponent] Namespace "${entry.namespace}" is already registered`);
    }
    registryMap.set(entry.namespace, entry);
  }
}

/** Clear all registered namespaces. Test-only. */
export function resetRegistry() {
  if (process.env.NODE_ENV === 'production') {
    return;
  }
  registryMap.clear();
}

/** Look up a lazy component by namespace and customComponentType. Returns null if namespace or component is not found. */
export function resolveComponent(namespace, customComponentType) {
  var _entry$components$cus;
  const entry = registryMap.get(namespace);
  if (!entry) return null;
  return (_entry$components$cus = entry.components[customComponentType]) !== null && _entry$components$cus !== void 0 ? _entry$components$cus : null;
}